import { jsxs as v, jsx as i, Fragment as Y } from "react/jsx-runtime";
import C, { clsx as w } from "clsx";
import { createContext as A, useCallback as N, useMemo as L, useContext as E, useState as k, Children as K, lazy as Q, Suspense as V, useRef as X, useEffect as B } from "react";
import Z from "@sanity/image-url";
function O({ className: e }) {
  return /* @__PURE__ */ v("svg", { viewBox: "0 0 16 16", className: e, children: [
    /* @__PURE__ */ i("path", { d: "M8 16L8 -5.96046e-08", stroke: "currentColor" }),
    /* @__PURE__ */ i("path", { d: "M0 8L16 8", stroke: "currentColor" })
  ] });
}
O.displayName = "IconPlus";
function z({ className: e }) {
  return /* @__PURE__ */ i("svg", { viewBox: "0 0 16 16", className: e, children: /* @__PURE__ */ i("path", { d: "M0 8L16 8", stroke: "currentColor" }) });
}
z.displayName = "IconMinus";
const D = A(null);
function _e({
  locale: e,
  children: n,
  sanityClient: t,
  onTrackingEvent: r,
  renderLink: o = (s) => /* @__PURE__ */ i("a", { ...s })
}) {
  const s = N(
    (f) => {
      r == null || r(f);
    },
    [r]
  ), c = L(() => Z(t), [t]), l = { locale: e, renderLink: o, emitTrackingEvent: s, sanityClient: t, imageUrlBuilder: c };
  return /* @__PURE__ */ i(D.Provider, { value: l, children: n });
}
const S = () => {
  const e = E(D);
  if (!e)
    throw new Error("No context for UI. You probably forgot to add the UIProvider.");
  return e;
}, Ce = () => S().locale, ee = () => S().emitTrackingEvent;
function Ie() {
  return S().sanityClient;
}
function te() {
  return S().imageUrlBuilder;
}
const M = A(null);
function ne({ defaultOpenSections: e, autoClose: n = !1, onToggleSection: t, children: r }) {
  const [o, s] = k(e ?? []), c = L(
    () => K.map(r, (d, a) => {
      if (d.type.displayName !== "AccordionSection")
        throw new Error("AccordionSection must be a direct descendant of Accordion.");
      return {
        index: a,
        // @ts-expect-error
        id: d.props.id ?? "",
        // @ts-expect-error
        title: d.props.title ?? ""
      };
    }) ?? [],
    [r]
  ), l = ee(), f = N(
    (d) => {
      s((a) => {
        const u = a.includes(d), y = c.find((m) => m.id === d);
        return y ? (t == null || t({
          ...y,
          sectionCount: c.length,
          action: u ? "closed" : "opened"
        }), l({
          event: "select_content",
          type: "accordion",
          text: y.title,
          action: u ? "closed" : "opened",
          index: {
            index_section: y.index + 1,
            index_section_count: c.length
          }
        }), u ? a.filter((m) => m !== d) : n ? [d] : [...a, d]) : a;
      });
    },
    [c, n]
  ), x = N((d) => o.includes(d), [o]), h = { toggleSection: f, isOpen: x };
  return /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i(M.Provider, { value: h, children: r }) });
}
ne.displayName = "Accordion";
function re({ id: e, title: n, children: t }) {
  const { toggleSection: r, isOpen: o } = E(M), s = o(e);
  return /* @__PURE__ */ v("section", { className: "flex flex-col border-b border-quaternary", children: [
    /* @__PURE__ */ i("h2", { className: "flex", children: /* @__PURE__ */ v(
      "button",
      {
        "aria-expanded": s,
        id: `accordion-title-${e}`,
        onClick: () => r(e),
        "aria-controls": `accordion-text-${e}`,
        className: "flex flex-1 items-center justify-between py-mini",
        children: [
          /* @__PURE__ */ i("span", { className: w(s && "font-medium"), children: n }),
          /* @__PURE__ */ i("span", { children: s ? /* @__PURE__ */ i(z, { className: "w-mini" }) : /* @__PURE__ */ i(O, { className: "w-mini" }) })
        ]
      }
    ) }),
    /* @__PURE__ */ i(
      "div",
      {
        role: "region",
        id: `accordion-text-${e}`,
        "aria-labelledby": `accordion-title-${e}`,
        className: w("grid overflow-hidden transition-all", s ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"),
        children: /* @__PURE__ */ i("div", { className: "overflow-hidden", children: /* @__PURE__ */ i("div", { className: "pb-mini", children: t }) })
      }
    )
  ] });
}
re.displayName = "AccordionSection";
function Le({ onClick: e, children: n, variant: t = "secondary" }) {
  return /* @__PURE__ */ i(
    "button",
    {
      onClick: e,
      className: w("text-white px-mini py-micro rounded-nano", t === "primary" && "bg-primary", t === "secondary" && "bg-quaternary"),
      children: n
    }
  );
}
function I({ children: e, className: n, headingStyle: t = "serif" }) {
  return /* @__PURE__ */ i("div", { className: w(n, "richtext", t === "sans-serif" && "richtext-sans-serif"), children: e });
}
I.displayName = "RichText";
function Se({ children: e, className: n }) {
  return /* @__PURE__ */ i("div", { className: w(n, "flex items-center border-l-4 border-primary bg-white p-midi"), children: /* @__PURE__ */ i(I, { className: "text-primary", children: e }) });
}
const ie = (e) => {
  const { renderLink: n } = S();
  return n(e);
};
function F({ data: e, children: n }) {
  const t = e._type === "link" ? e.link : oe(e);
  return t ? /* @__PURE__ */ i(ie, { href: t, title: e.title ?? void 0, children: n }) : null;
}
F.displayName = "SanityLink";
function oe(e) {
  var r, o;
  const n = (r = e.document.slug) == null ? void 0 : r.current, t = (o = e.document.shopify) == null ? void 0 : o.shopifyHandle;
  return e.document._type === "pageArticles" ? "/articles" : e.document._type === "pageCart" ? "/cart" : e.document._type === "pageCollections" ? "/collections" : e.document._type === "pageContact" ? "/contact" : e.document._type === "pageFlexible" && n ? `/${n}` : e.document._type === "pageHomepage" ? "/" : e.document._type === "pageSearch" ? "/search" : e.document._type === "article" && n ? `/articles/${n}` : e.document._type === "product" && t ? `/products/${t}` : e.document._type === "collection" && t ? `/collections/${t}` : e.document._type === "store" && n ? `/store-locations/${n}` : (console.error("Could not resolve href for internal link.", { data: e }), null);
}
function q({
  data: e,
  sizes: n,
  altText: t,
  className: r,
  loading: o = "lazy",
  customWidthSteps: s,
  maxWidth: c,
  minimumWidthStep: l = se
}) {
  const f = te(), [x, h] = k(!1), d = L(() => {
    const y = e._type === "image" ? e.asset : e._type === "sanity.imageAsset" ? { _type: "reference", _ref: e._id } : e;
    if (!y)
      return console.warn("Could not resolve asset from Sanity data.", { data: e }), null;
    const m = typeof c == "number" ? c : ce, _ = f.image(e).fit("max").auto("format"), b = le(y);
    if (!b)
      return console.error("Could not calculate image dimensions from asset.", { asset: y }), null;
    const T = [m, ...s || (typeof c == "number" ? ae : ue)], P = Array.from(
      // De-duplicate sizes with a Set
      /* @__PURE__ */ new Set([...T, ...T.map((p) => p * 2), ...T.map((p) => p * 3)])
    ).sort((p, U) => p - U).filter(
      (p) => (
        // Exclude sizes 10% or more larger than the image itself. Sizes slightly larger
        // than the image are included to ensure we always get closest to the highest
        // quality for an image. Sanity's CDN won't scale the image above its limits.
        p <= b.width * 1.1 && // Exclude those larger than maxWidth's retina (x3)
        p <= m * 3
      )
    ).filter((p, U, W) => {
      const R = W[U + 1];
      return R ? R / p > l + 1 : !0;
    });
    return {
      // Use the original image as the `src` for the <img>
      src: _.width(m).url(),
      // Build a `{URL} {SIZE}w, ...` string for the srcset
      srcSet: P.map((p) => `${_.width(p).url()} ${p}w`).join(", "),
      sizes: c === "100vw" ? "100vw" : n || `(max-width: ${m}px) 100vw, ${m}px`,
      // Let's also tell the browser what's the size of the image so it can calculate aspect ratios
      width: P[0],
      height: P[0] / b.aspectRatio,
      // Set lazy loading.
      loading: o,
      fetchPriority: o === "eager" ? "high" : void 0,
      // Ensure never renders bigger than max width.
      style: typeof c == "number" ? { maxWidth: `${c}px` } : void 0
    };
  }, [f, e, c, l, s, n, o]);
  if (!d)
    return console.error("Unable to generate image props. Cannot render SanityImage."), null;
  const { fetchPriority: a, ...u } = d;
  return /* @__PURE__ */ i(
    "img",
    {
      ...u,
      alt: t,
      fetchpriority: a,
      onLoad: () => h(!0),
      className: w("w-full transition-opacity", r, !x && "opacity-0")
    }
  );
}
q.displayName = "SanityImage";
const ce = 1920, se = 0.1, ae = [400, 600, 850, 1e3, 1150], ue = [360, 414, 768, 1366, 1536, 1920];
function le(e) {
  const n = e._ref.split("-")[2], [t, r] = n.split("x").map(Number);
  return !t || !r || Number.isNaN(t) || Number.isNaN(r) ? null : {
    width: t,
    height: r,
    aspectRatio: t / r
  };
}
function $({ data: e }) {
  var r;
  if (!e.asset)
    return null;
  const n = /* @__PURE__ */ i(q, { data: e.asset, altText: e.alt ?? "", maxWidth: e.displayWidth ?? "100vw" }), t = (r = e.imagelink) == null ? void 0 : r[0];
  return t && t._type !== "unknown" ? /* @__PURE__ */ i(F, { data: t, children: n }) : n;
}
$.displayName = "CustomImage";
const de = Q(() => import(
  /* webpackChunkName: "react-player" */
  "react-player"
));
function j({ controls: e = !1, fallbackImage: n, loop: t = !0, muted: r = !0, playing: o = !0, videoUrl: s }) {
  return /* @__PURE__ */ i("div", { className: "h-full w-full", children: /* @__PURE__ */ i(V, { fallback: /* @__PURE__ */ i($, { data: n }), children: /* @__PURE__ */ i(de, { controls: e, loop: t, muted: r, playing: o, playsinline: !0, url: s, width: "100%", height: "100%" }) }) });
}
function $e({
  bannerTextColor: e,
  children: n,
  desktopBanner: t,
  desktopImage: r,
  desktopVideoUrl: o,
  mobileBanner: s,
  mobileImage: c,
  mobileVideoUrl: l
}) {
  return /* @__PURE__ */ v("div", { className: "relative", children: [
    /* @__PURE__ */ i("div", { className: "hidden w-full md:block", children: o ? /* @__PURE__ */ i(j, { videoUrl: o, fallbackImage: r }) : /* @__PURE__ */ i($, { data: r }) }),
    /* @__PURE__ */ i("div", { className: "block w-full md:hidden", children: l ? /* @__PURE__ */ i(j, { videoUrl: l, fallbackImage: c }) : /* @__PURE__ */ i($, { data: c }) }),
    /* @__PURE__ */ v("div", { className: C(e === "lightest" ? "text-white" : "text-primary", "absolute top-zero z-10 px-midi"), children: [
      n,
      /* @__PURE__ */ i(I, { className: "mt-mini hidden md:block", children: t }),
      /* @__PURE__ */ i(I, { className: "mt-micro block md:hidden", children: s })
    ] })
  ] });
}
function G({ className: e }) {
  return /* @__PURE__ */ i("svg", { viewBox: "0 0 9 5", fill: "none", className: e, children: /* @__PURE__ */ i("path", { d: "M1 1L4.5 4L8 1", stroke: "currentColor", strokeLinejoin: "round" }) });
}
G.displayName = "IconArrowDropdown";
function Te({ children: e }) {
  const n = X(null), t = N(() => {
    if (!n.current)
      return !1;
    if (1 < n.current.querySelectorAll("p").length)
      return !0;
    const f = n.current.querySelector("p:first-of-type");
    return f ? f.scrollHeight > f.clientHeight : !1;
  }, [n]), [r, o] = k(!1), [s, c] = k(!1);
  return B(() => {
    o(t());
    const l = () => {
      c(!1), setTimeout(() => o(t()), 1);
    };
    return window.addEventListener("resize", l), () => {
      window.removeEventListener("resize", l);
    };
  }, [n, t]), /* @__PURE__ */ v(Y, { children: [
    /* @__PURE__ */ i(
      "div",
      {
        ref: n,
        className: C(
          "line-clamp-2 block w-full text-primary [&>*]:!text-left [&_p]:!mb-zero",
          !s && "[&_p:first-of-type]:line-clamp-2 [&_p:not(:first-of-type)]:hidden"
        ),
        dangerouslySetInnerHTML: { __html: e }
      }
    ),
    r && /* @__PURE__ */ v(
      "span",
      {
        onClick: () => c((l) => !l),
        className: "mt-pico flex w-[fit-content] cursor-pointer items-center border-b border-primary text-primary",
        children: [
          s ? "Read Less" : "Read More",
          /* @__PURE__ */ i(G, { className: C("mx-pico h-mini w-mini text-primary", s ? "rotate-180" : null) })
        ]
      }
    )
  ] });
}
const J = A(null);
function fe({ children: e, delay: n = 3e3, className: t }) {
  const r = L(() => e ? Array.isArray(e) ? e.map((a) => a.props.id) : [] : [], [e]), [o, s] = k(r[0]), c = N(() => {
    s((a) => {
      if (!a)
        return r[0];
      const u = r.indexOf(a);
      return u >= r.length - 1 ? r[0] : r[u + 1];
    });
  }, [r]), l = N(
    () => window.setInterval(() => {
      c();
    }, n),
    [n, c]
  ), [, f] = k(null);
  B(() => {
    f((a) => a || l());
  }, []);
  const x = () => {
    f((a) => (a && clearInterval(a), null));
  }, h = () => {
    f((a) => a || l());
  };
  if (typeof o > "u")
    return console.error("Could not resolve currentItemId in Ticker component. Check children."), null;
  const d = { currentItemId: o };
  return /* @__PURE__ */ i("div", { onMouseOver: x, onMouseLeave: h, className: C(t, "flex items-center justify-center text-primary"), children: /* @__PURE__ */ i(J.Provider, { value: d, children: e }) });
}
function Pe({ id: e, children: n }) {
  const { currentItemId: t } = E(J), r = t == e;
  return /* @__PURE__ */ i(
    "div",
    {
      tabIndex: 0,
      className: C(
        r && "pointer-events-auto opacity-100",
        "pointer-events-none absolute flex items-center justify-center space-x-micro text-center text-primary opacity-0 transition-opacity duration-1000 motion-reduce:transition-none"
      ),
      children: n
    }
  );
}
fe.displayName = "Ticker";
function g(e, n = !1) {
  (typeof e == "string" || e instanceof String) && (e = JSON.parse(e));
  let t = "";
  if (e.type === "root" && e.children.length > 0)
    n ? t += `
        <div class="${n === !0 ? "rte" : n}">
          ${g(e.children)}
        </div>
        ` : t += g(e.children);
  else
    for (const r of e)
      switch (r.type) {
        case "paragraph":
          t += pe(r);
          break;
        case "heading":
          t += me(r);
          break;
        case "list":
          t += he(r);
          break;
        case "list-item":
          t += ye(r);
          break;
        case "link":
          t += ge(r);
          break;
        case "text":
          t += xe(r);
          break;
      }
  return t;
}
function pe(e) {
  if (e != null && e.children)
    return `<p>${g(e == null ? void 0 : e.children)}</p>`;
}
function me(e) {
  if (e != null && e.children)
    return `<h${e == null ? void 0 : e.level}>${g(e == null ? void 0 : e.children)}</h${e == null ? void 0 : e.level}>`;
}
function he(e) {
  if (e != null && e.children)
    return (e == null ? void 0 : e.listType) === "ordered" ? `<ol>${g(e == null ? void 0 : e.children)}</ol>` : `<ul>${g(e == null ? void 0 : e.children)}</ul>`;
}
function ye(e) {
  if (e != null && e.children)
    return `<li>${g(e == null ? void 0 : e.children)}</li>`;
}
function ge(e) {
  return `<a href="${e == null ? void 0 : e.url}" title="${e == null ? void 0 : e.title}" target="${e == null ? void 0 : e.target}">${g(e == null ? void 0 : e.children)}</a>`;
}
function xe(e) {
  return e != null && e.bold ? `<strong>${e == null ? void 0 : e.value}</strong>` : e != null && e.italic ? `<em>${e == null ? void 0 : e.value}</em>` : e == null ? void 0 : e.value;
}
function ve({ content: e, className: n }) {
  const t = L(() => g(e), [e]);
  return /* @__PURE__ */ i(I, { className: n, children: /* @__PURE__ */ i("div", { dangerouslySetInnerHTML: { __html: t } }) });
}
ve.displayName = "ShopifyRichText";
function Ue(e) {
  return e.meta.map((n) => {
    const t = n;
    if (t.title && typeof t.title == "string")
      return /* @__PURE__ */ i("title", { children: t.title });
    if (t.content && typeof t.content == "string")
      return /* @__PURE__ */ i("meta", { ...t });
    if (t.tagName === "link") {
      const { tagName: r, ...o } = t;
      return /* @__PURE__ */ i("link", { ...o });
    }
    return t["script:ld+json"] && typeof t["script:ld+json"] == "object" ? /* @__PURE__ */ i("script", { type: "application/ld+json", children: JSON.stringify(t["script:ld+json"]) }) : null;
  });
}
function Ae(e, { locales: n }) {
  const t = H(e), r = new URL(t), o = r.pathname.split("/").filter(Boolean).map((u) => u.toLowerCase()), c = n.map(({ prefix: u }) => u).includes(o[0]) ? o[0] : null, l = c ? o.slice(1) : o, f = "/" + l.join("/"), x = H(r.origin + f), h = n.find((u) => c === u.prefix) ?? n.find((u) => u.prefix === null) ?? null, d = h ? (() => {
    var _, b;
    const u = h.identifier.split("-"), y = (_ = u[0]) == null ? void 0 : _.toUpperCase();
    if (!y)
      throw new Error(`Language code could not be resolved from identifier ${h.identifier}.`);
    const m = (b = u[1]) == null ? void 0 : b.toUpperCase();
    if (!m)
      throw new Error(`Country code could not be resolved from identifier ${h.identifier}.`);
    return { ...h, languageCode: y, countryCode: m };
  })() : null, a = n.map((u) => ({
    language: u.identifier,
    url: [r.origin, u.prefix, ...l].filter(Boolean).join("/")
  }));
  return {
    locale: d,
    globalUrl: x,
    globalPath: f,
    localizedUrls: a,
    origin: r.origin,
    path: r.pathname,
    url: t,
    canonicalUrl: t
  };
}
function H(e) {
  return e.endsWith("/") ? e.substring(0, e.length - 1) : e;
}
export {
  ne as Accordion,
  re as AccordionSection,
  Le as Button,
  Se as Callout,
  $e as CollectionHeroBanner,
  $ as CustomImage,
  Te as Disclosure,
  G as IconArrowDropdown,
  z as IconMinus,
  O as IconPlus,
  ie as Link,
  Ue as MetaComponent,
  I as RichText,
  q as SanityImage,
  F as SanityLink,
  ve as ShopifyRichText,
  fe as Ticker,
  Pe as TickerSection,
  D as UIContext,
  _e as UIProvider,
  j as Video,
  oe as resolveInternalLink,
  Ae as resolveUrlContext,
  S as useContext,
  ee as useEmitTrackingEvent,
  te as useImageUrlBuilder,
  Ce as useLocale,
  Ie as useSanityClient
};
